module.exports = __webpack_public_path__ + "static/media/icon_vaitro_nguoidun.2ed71fb8.svg";